// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LMGlobalPersistenceService } from '@services/lm-global-persistence.service';

@Injectable()
export class LMGlobalStorageService implements LMStorageServiceBase {

  constructor(private persistenceService: LMGlobalPersistenceService) {
  }

  public getItem(keyParams: LMKeyParamsBase): LMStorageModelBase {
    return this.persistenceService.getItem(keyParams.key);
  }

  public saveItem(keyParams: LMKeyParamsBase, payload: LMStorageModelBase): void {
    this.persistenceService.saveItem(keyParams.key, payload);
  }

  public deleteItem(keyParams: LMKeyParamsBase): void {
    this.persistenceService.deleteItem(keyParams.key);
  }
}

export class LMGlobalStorageKeyParams implements LMKeyParamsBase {
  storageKey: string;
  resourceId: string;
  contextResourceId?: string;

  private _key = '';

  get key() {
    if (!this._key) {
      this.buildKey();
    }
    return this._key;
  }

  private buildKey(): void {
    this._key = this.storageKey;
    this._key = this._key.replace('{resourceId}', this.resourceId);
    this._key = this._key.replace('{contextResourceId}', this.contextResourceId);
  }
}
